// ══════════════════════════════════════════════════════════════════════════════
// DEEPSPACE v4.0 — Instant Evidence-Based Scoring Engine
// Computes all 4 anomaly scores from incident data immediately
// No AI call needed — derived purely from factual evidence
// AI call then enriches these baseline scores
// ══════════════════════════════════════════════════════════════════════════════

// Real FOIA and government document URLs by tracking ID / source
const FOIA_DOCUMENTS = {
  // FBI Vault
  'BB-1947-NM-001': [
    { title:'FBI Memo — Flying Discs Jul 8 1947', url:'https://vault.fbi.gov/UFO/UFO%20Part%201%20of%2016/view', type:'FBI FOIA', date:'1947-07-08' },
    { title:'FBI Director Hoover Memo — Cooperation on Flying Discs', url:'https://vault.fbi.gov/UFO/UFO%20Part%201%20of%2016/view', type:'FBI FOIA', date:'1947-09-27' },
    { title:'RAAF Press Release — Recovery of Flying Disc', url:'https://www.nara.gov/research/record-groups/rg-341.html', type:'NARA FOIA', date:'1947-07-08' },
  ],
  'BB-1952-DC-019': [
    { title:'USAF Project Blue Book Special Report #14', url:'https://www.fold3.com/page/301681-project-blue-book', type:'NARA FOIA', date:'1952-07-19' },
    { title:'CAA Air Traffic Control Report — Washington Overflights', url:'https://www.nara.gov', type:'NARA FOIA', date:'1952-07-20' },
    { title:'General Samford Press Conference Transcript', url:'https://www.fold3.com/page/301681-project-blue-book', type:'USAF FOIA', date:'1952-07-29' },
  ],
  'AARO-2004-PAC-001': [
    { title:'DoD Release — UAP Videos Authenticated', url:'https://www.defense.gov/News/Releases/Release/Article/2165713/', type:'DoD Official', date:'2020-04-27' },
    { title:'AARO Historical Record — USS Nimitz 2004', url:'https://www.aaro.mil/Our-Work/AARO-Historical-Record-Report/', type:'AARO', date:'2024-03-08' },
    { title:'USS Princeton Radar Track Documentation', url:'https://www.aaro.mil', type:'AARO', date:'2004-11-14' },
  ],
  'AARO-2015-ATL-007': [
    { title:'DoD Statement Authenticating GIMBAL/GOFAST', url:'https://www.defense.gov/News/Releases/Release/Article/2165713/', type:'DoD Official', date:'2019-09-18' },
    { title:'AARO FY2024 Annual Report to Congress', url:'https://www.aaro.mil/Portals/136/PDFs/AARO_Historical_Record_Report_Vol_1_2024.pdf', type:'AARO', date:'2024-03-08' },
  ],
  'AARO-2019-PAC-USS-OMAHA': [
    { title:'DoD Authentication — USS Omaha UAP Footage', url:'https://www.defense.gov/News/Releases/Release/Article/2165713/', type:'DoD Official', date:'2021-04-06' },
    { title:'AARO Active Case Reference', url:'https://www.aaro.mil/Report-a-UAP/', type:'AARO', date:'2021-04-06' },
  ],
  'CONGRESS-2023-NDAA-UAP': [
    { title:'Congressional Hearing Transcript — Grusch Testimony', url:'https://www.congress.gov/event/118th-congress/house-event/116282', type:'Congressional Record', date:'2023-07-26' },
    { title:'ICIG Finding — Complaint Credible and Urgent', url:'https://www.intelligence.senate.gov', type:'ICIG', date:'2023-07-26' },
    { title:'NDAA 2024 — UAP Disclosure Act Provisions', url:'https://www.congress.gov/bill/118th-congress/senate-bill/2226', type:'Federal Law', date:'2023-12-22' },
  ],
  'MOD-1980-UK-048': [
    { title:'Lt. Col. Halt Memo to UK MoD — Jan 13 1981', url:'https://discovery.nationalarchives.gov.uk/details/r/C11931536', type:'UK National Archives', date:'1981-01-13' },
    { title:'UK MoD DEFE 24/1948 — Rendlesham Forest Incident', url:'https://discovery.nationalarchives.gov.uk/details/r/C11931536', type:'UK FOIA', date:'2001-01-01' },
    { title:'USAF Security Police Report — Rendlesham 1980', url:'https://discovery.nationalarchives.gov.uk', type:'UK National Archives', date:'1980-12-28' },
  ],
  'MOD-1993-UK-COS': [
    { title:'UK MoD File — RAF Cosford/Shawbury 1993', url:'https://discovery.nationalarchives.gov.uk', type:'UK National Archives', date:'2011-01-01' },
  ],
  'BB-1967-MT-MALM': [
    { title:'USAF FOIA — Malmstrom AFB UAP Incident 1967', url:'https://www.afhra.af.mil', type:'USAF FOIA', date:'1967-03-16' },
    { title:'Captain Robert Salas Testimony — FOIA Documents', url:'https://www.nuclearufo.com/foia.htm', type:'USAF FOIA', date:'1967-03-16' },
  ],
  'GEPAN-1981-FR-TEP': [
    { title:'GEPAN Technical Note 16 — Trans-en-Provence', url:'https://www.cnes.fr/en/gepan-investigation-began', type:'GEPAN Official', date:'1981-01-08' },
  ],
  'USCG-2013-PR-AGU': [
    { title:'SCU Peer-Reviewed Analysis — Aguadilla Puerto Rico', url:'https://www.explorescu.org/post/aguadilla-puerto-rico-uap', type:'Scientific Peer Review', date:'2015-05-01' },
  ],
  'NASA-2023-UAP-FINAL': [
    { title:'NASA UAP Independent Study Team Final Report', url:'https://science.nasa.gov/uap', type:'NASA Official', date:'2023-09-14' },
    { title:'NASA UAP Report — Full PDF', url:'https://smd-cms.nasa.gov/wp-content/uploads/2023/09/uap-independent-study-team-final-report.pdf', type:'NASA PDF', date:'2023-09-14' },
  ],
  'AARO-FY2023-CONGRESS': [
    { title:'AARO FY2023 Annual Report to Congress', url:'https://media.defense.gov/2024/Feb/12/2003394862/-1/-1/0/FY2023-CONSOLIDATED-ANNUAL-REPORT-TO-CONGRESS.PDF', type:'DoD PDF', date:'2024-02-12' },
  ],
  'AARO-FY2024-CONGRESS': [
    { title:'AARO Historical Record Report Vol. 1', url:'https://www.aaro.mil/Portals/136/PDFs/AARO_Historical_Record_Report_Vol_1_2024.pdf', type:'AARO PDF', date:'2024-03-08' },
  ],
  'DIA-1976-IRAN-F4': [
    { title:'Defense Intelligence Agency Report — Tehran F-4 Intercept', url:'https://nsarchive.gwu.edu/document/16251-document-7-defense-intelligence-agency-report', type:'DIA FOIA', date:'1976-09-19' },
  ],
  'NUFORC-1997-AZ-PHX': [
    { title:'NUFORC Database — Phoenix Lights 1997', url:'https://nuforc.org/webreports/ndxe199703.html', type:'NUFORC', date:'1997-03-13' },
    { title:'Governor Symington Statement 2007', url:'https://www.cnn.com/2007/TECH/science/03/12/ufo.governor/index.html', type:'News Archive', date:'2007-03-12' },
  ],
};

// Default FOIA documents for categories
const DEFAULT_FOIA = {
  aaro:    [{ title:'AARO UAP Reports Database', url:'https://www.aaro.mil/Report-a-UAP/', type:'AARO' }],
  fbi:     [{ title:'FBI Vault — UFO Files', url:'https://vault.fbi.gov/UFO', type:'FBI FOIA' }],
  nara:    [{ title:'NARA Project Blue Book Records', url:'https://www.fold3.com/page/301681-project-blue-book', type:'NARA FOIA' }],
  congress:[{ title:'Congressional UAP Hearings', url:'https://www.congress.gov', type:'Congressional Record' }],
  nuforc:  [{ title:'NUFORC Report Database', url:'https://nuforc.org/webreports/', type:'NUFORC' }],
  nasa:    [{ title:'NASA UAP Research', url:'https://science.nasa.gov/uap', type:'NASA' }],
};

// Get real document links for an incident
export function getDocumentLinks(inc) {
  const tracking = inc.tracking || '';
  const source   = (inc.source || '').toLowerCase();
  const sourceUrl = inc.sourceUrl || '';

  // Check specific tracking ID first
  if (FOIA_DOCUMENTS[tracking]) return FOIA_DOCUMENTS[tracking];

  // Build from source text
  const docs = [];

  // Always include the primary source URL
  if (sourceUrl && sourceUrl !== 'https://www.nuforc.org' && sourceUrl !== 'https://www.nicap.org') {
    docs.push({
      title:  inc.source?.split('·')[0]?.trim() || 'Primary Source',
      url:    sourceUrl,
      type:   source.includes('aaro') ? 'AARO Official' :
              source.includes('fbi')  ? 'FBI FOIA' :
              source.includes('nasa') ? 'NASA Official' :
              source.includes('congress') ? 'Congressional Record' : 'Government Source',
    });
  }

  // Add category-specific docs
  if (source.includes('aaro'))     docs.push(...DEFAULT_FOIA.aaro);
  if (source.includes('fbi') || source.includes('vault')) docs.push(...DEFAULT_FOIA.fbi);
  if (source.includes('blue book') || source.includes('nara')) docs.push(...DEFAULT_FOIA.nara);
  if (source.includes('congress')) docs.push(...DEFAULT_FOIA.congress);
  if (source.includes('nuforc'))   docs.push(...DEFAULT_FOIA.nuforc);
  if (source.includes('nasa'))     docs.push(...DEFAULT_FOIA.nasa);

  // Always add AARO as supplementary
  if (!source.includes('aaro')) {
    docs.push({ title:'AARO Historical Records Database', url:'https://www.aaro.mil/Our-Work/AARO-Historical-Record-Report/', type:'AARO Supplementary' });
  }

  return docs.length > 0 ? docs : [
    { title: inc.source?.split('·')[0]?.trim() || 'Source Document', url: sourceUrl || 'https://www.aaro.mil', type: 'Primary Source' },
    { title: 'FBI Vault — UFO Files', url: 'https://vault.fbi.gov/UFO', type: 'FBI FOIA' },
    { title: 'AARO Historical Records', url: 'https://www.aaro.mil/Our-Work/AARO-Historical-Record-Report/', type: 'AARO' },
  ];
}

// ── INSTANT SCORING — computed from factual incident data immediately ─────────
// No AI call. Derived from evidence: witnesses, sources, type, military, nuclear.

export function computeInstantScores(inc) {
  const desc      = ((inc.description || '') + ' ' + (inc.name || '') + ' ' + (inc.classification || '')).toLowerCase();
  const sources   = (inc.source || '').split('·').filter(Boolean).length;
  const witnesses = inc.witnesses || 0;
  const conf      = inc.confidence || 70;

  // ── PHYSICS ANOMALY SCORE ─────────────────────────────────────────────────
  // Based on reported physical characteristics that defy conventional physics
  let physics = 0;
  if (desc.includes('80,000ft') || desc.includes('instant') || desc.includes('one second'))  physics += 25; // Impossible acceleration
  if (desc.includes('no wings') || desc.includes('no propulsion') || desc.includes('no exhaust')) physics += 20; // No propulsion
  if (desc.includes('transmedium') || desc.includes('entered the ocean') || desc.includes('water')) physics += 25; // Transmedium
  if (desc.includes('silent') || desc.includes('no sound') || desc.includes('no heat'))      physics += 15; // No acoustic/thermal
  if (desc.includes('disappeared') || desc.includes('instant acceleration'))                  physics += 15; // Instant movement
  if (desc.includes('7,200mph') || desc.includes('1,800km') || desc.includes('mach'))        physics += 20; // Impossible speed
  if (desc.includes('radar') && desc.includes('no') && !desc.includes('no radar'))           physics += 10; // Radar anomaly
  if (desc.includes('40g') || desc.includes('impossible') || desc.includes('impossible'))    physics += 15; // G-force
  if (desc.includes('magnetic') || desc.includes('electromagnetic') || desc.includes('engine failure')) physics += 10; // EM effects
  if (inc.type === 'intercept' || inc.type === 'radar') physics += 10;
  physics = Math.min(98, physics);

  // ── INCIDENT VERACITY SCORE ───────────────────────────────────────────────
  // Based on source quality, witness count, government confirmation
  let veracity = 0;
  veracity += Math.min(20, sources * 7);                    // Multiple sources
  veracity += Math.min(20, Math.log10(Math.max(1, witnesses)) * 8); // Witness count
  if (conf > 90) veracity += 25;                            // High base confidence
  else if (conf > 80) veracity += 18;
  else if (conf > 70) veracity += 10;
  if (desc.includes('dod') || desc.includes('pentagon') || desc.includes('confirmed')) veracity += 20;
  if (desc.includes('foia') || desc.includes('declassified') || desc.includes('official')) veracity += 15;
  if (desc.includes('congressional') || desc.includes('testimony'))  veracity += 15;
  if (desc.includes('radar') && desc.includes('visual'))             veracity += 10; // Multi-sensor
  if (desc.includes('photograph') || desc.includes('film') || desc.includes('footage')) veracity += 10; // Physical evidence
  if (desc.includes('physical') || desc.includes('trace') || desc.includes('burn'))    veracity += 12; // Physical trace
  if (inc.type === 'intercept') veracity += 10;             // Military intercept
  veracity = Math.min(98, veracity);

  // ── GEOGRAPHIC RISK SCORE ─────────────────────────────────────────────────
  let geoRisk = 30; // baseline
  const lat = inc.lat || 0, lng = inc.lng || 0;
  // Nuclear proximity
  const nuclearSites = [[37.23,-115.81],[47.51,-111.18],[48.41,-101.35],[35.04,-106.60],[46.56,-119.49]];
  nuclearSites.forEach(([nlat,nlng]) => {
    const dist = Math.sqrt((lat-nlat)**2+(lng-nlng)**2)*111;
    if (dist < 200) geoRisk += 25;
    else if (dist < 500) geoRisk += 12;
  });
  // Military zone proximity
  if (Math.abs(lat-37.23)<5 && Math.abs(lng+115.81)<5) geoRisk += 20; // Area 51
  if (desc.includes('nuclear') || desc.includes('icbm') || desc.includes('missile')) geoRisk += 20;
  if (desc.includes('military') || desc.includes('air force') || desc.includes('navy')) geoRisk += 10;
  if (desc.includes('restricted') || desc.includes('airspace')) geoRisk += 15;
  geoRisk = Math.min(98, geoRisk);

  // ── PATTERN MATCH SCORE ───────────────────────────────────────────────────
  // Based on similarity to confirmed DoD cases
  const patternMatch = Math.round(conf * 0.85 + sources * 2);

  return {
    physicsAnomalyScore:  physics,
    incidentVeracity:     Math.round(veracity),
    geographicRiskFactor: geoRisk,
    patternMatch:         Math.min(98, patternMatch),
    confidence:           conf,
    // Derived labels
    propulsionSignature:
      desc.includes('no propulsion') || desc.includes('no exhaust') ? 'No conventional propulsion detected' :
      desc.includes('plasma') ? 'Plasma/EM propulsion signature' :
      desc.includes('silent') ? 'Silent — no exhaust or acoustic signature' :
      'Unknown propulsion system',
    militaryCorrelation:
      desc.includes('f/a-18') || desc.includes('f-16') || desc.includes('f-4') ? 'Military intercept confirmed' :
      desc.includes('radar') ? 'Military radar tracking confirmed' :
      desc.includes('navy') || desc.includes('air force') ? 'Military personnel witnesses' :
      'None detected',
    nuclearProximityAlert:
      desc.includes('nuclear') || desc.includes('icbm') || desc.includes('missile') || geoRisk > 60,
    detectionType:
      inc.type === 'intercept' ? 'MILITARY INTERCEPT' :
      inc.type === 'radar'     ? 'MULTI-SENSOR RADAR' :
      inc.type === 'landing'   ? 'LANDING/PHYSICAL TRACE' :
      inc.type === 'crash'     ? 'CRASH RETRIEVAL' :
      inc.type === 'formation' ? 'MASS FORMATION' :
      inc.type === 'missing'   ? 'PILOT DISAPPEARANCE' :
      'UAP SIGHTING',
  };
}
